import { isToday } from 'date-fns';
import React from 'react';
import { Card } from 'react-bootstrap';
import Accordion from 'react-bootstrap/Accordion';
import ImgComponent from '../../../../HOCs/ImageHocs';
import {
  IMAGE_CROP_MODES,
  IMAGE_MODE,
} from '../../../../constants/contentTypes';
import { getContentImageByMode } from '../../../../utils/imageUtils';
import './styles.scss';

function EPGChannelList({
  selectedProgramItem,
  contentNoImageProps,
  channelList = [],
  activeKey,
  scrollRef,
  handleOnScroll,
  imageMode = IMAGE_MODE.THUMB,
  handleOnSelectedProgramChannel,
  onClickBroadcast,
  selectedDay,
  broadcast,
  enableEpgDropdown,
}) {
  const onClickChannel = (c) => {
    if (isToday(selectedDay)) handleOnSelectedProgramChannel(c.epgId);
  };

  React.useEffect(() => {
    // Set default first channel when into the epg
    if (
      !activeKey &&
      !!channelList &&
      channelList.length > 0 &&
      !!selectedDay &&
      isToday(selectedDay)
    ) {
      onClickChannel(channelList[0]);
    } else {
      !!activeKey &&
        !!channelList &&
        channelList.length > 0 &&
        onClickChannel(channelList.find((c) => c.epgId === activeKey));
    }
  }, [activeKey]);
  /* React.useEffect(() => {
    if (isToday(selectedDay) && channel) {

      const channelResult = channelList.find((e) => (e.epgId === channel))

      const programItemResult = channelResult?.epg.find((programItem) => {
        return areIntervalsOverlapping(
          { start: new Date(), end: new Date() },
          { start: Date.parse(programItem.startTime), end: Date.parse(programItem.endTime) }),
          { inclusive: true }
      })

      if (programItemResult) {
        const channelR = channel;
        handleOnSelectedProgramItem(programItemResult, channelR)
        setChanel(false)
      }
    }
  }, [selectedDay]) */

  return (
    <div
      className="epgGridList_container_channel"
      onScroll={handleOnScroll}
      ref={scrollRef}
    >
      <Accordion className="epgGridList_row_channel" activeKey={activeKey}>
        {channelList?.length > 0 &&
          channelList.map((e, index) => (
            <Card
              className="epgGridList_row_channel_card"
              key={'epgGridList_row_channel_card-' + e.epgId + '-' + index}
            >
              <Card.Header
                className={`epgGridList_row_channel_header ${e.epgId === activeKey || (!activeKey && index === 0 && isToday(selectedDay)) ? 'epgGridList_row_channel_active' : ''}`}
              >
                <a
                  className="epgGridList_row_channel_header_container"
                  onClick={() => onClickChannel(e)}
                >
                  <div className="epgGridList_row_channel_container_img">
                    <ImgComponent
                      className="epgGridList_row_channel_img"
                      src={
                        getContentImageByMode(e.images, IMAGE_MODE.THUMB)?.url
                      }
                      crop={IMAGE_CROP_MODES.resizeScaleAndCrop}
                      size={IMAGE_MODE.THUMB}
                      setimagebool={(e) => console.log(e)}
                      alt={e.title}
                    />
                  </div>
                  {/* <div className="epgGridList_row_channel_container_title">
                <div className='epgGridList_row_channel_title'>{e.title}</div>
               </div> */}
                </a>
              </Card.Header>
              {enableEpgDropdown && (
                <Accordion.Collapse
                  className="epgGridList_row_channel_collapse"
                  eventKey={e.epgId}
                >
                  <Card.Body className="epgGridList_row_channel_body">
                    {!!selectedProgramItem &&
                      e.epgId === activeKey &&
                      (() => (
                        <div className="epgGridList_row_channel_body_img_container">
                          <ImgComponent
                            className="epgGridList_row_channel_body_img"
                            src={
                              getContentImageByMode(e.images, IMAGE_MODE.THUMB)
                                ?.url
                            }
                            crop={IMAGE_CROP_MODES.resizeScaleAndCrop}
                            size={imageMode}
                            setimagebool={(e) => console.log(e)}
                            alt={e.title + ' body'}
                          />
                        </div>
                      ))()}
                  </Card.Body>
                </Accordion.Collapse>
              )}
            </Card>
          ))}
      </Accordion>
    </div>
  );
}

export default React.memo(EPGChannelList);
